import { render, staticRenderFns } from "./wordsPage.vue?vue&type=template&id=bc3c881e&scoped=true&"
import script from "./wordsPage.vue?vue&type=script&lang=js&"
export * from "./wordsPage.vue?vue&type=script&lang=js&"
import style0 from "./wordsPage.vue?vue&type=style&index=0&id=bc3c881e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3c881e",
  null
  
)

export default component.exports